module.exports = __webpack_public_path__ + "static/prestashop-bf61b49000a8d4a410d87b2a572069d1.svg";